import {
	Container,
	ContainerPadding,
	CTA,
	ContainerGutter,
	TokenTextAppearance,
	TextAlignment,
	TokenTextColor,
	Text,
	ThemeProvider,
} from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import React from 'react';

export const AlertVehicleManagerLayer = ({
	onButtonClickClose,
	onVolverClose,
	errorCountRef,
}: {
	onButtonClickClose: () => void;
	onVolverClose: () => void;
	errorCountRef: React.MutableRefObject<number>;
}) => {
	return (
		<ThemeProvider theme={'inverted'}>
			<Container horizontalAlign={'flex-end'} padding={ContainerPadding.dynamic0100}>
				<CTA
					tag="button"
					emphasis="tertiary"
					onClick={onButtonClickClose}
					aria-label="closePopUp"
					icon={<Close variant="default" aria-hidden />}
				/>
			</Container>

			<Container
				wrap={'always'}
				padding={{
					left: ContainerPadding.dynamic0150,
					right: ContainerPadding.dynamic0150,
					bottom: ContainerPadding.dynamic0150,
				}}
				gutter={ContainerGutter.dynamic0050}
				horizontalAlign={'center'}
			>
				<Container
					wrap={'always'}
					gutter={ContainerGutter.dynamic0050}
					horizontalAlign={'center'}
					verticalAlign={'center'}
				>
					<Text appearance={TokenTextAppearance.headline400} textAlign={TextAlignment.center} bold>
						{errorCountRef.current > 1 ? 'Uy, ha habido un error' : '¡Ops, ha habido un error!'}
					</Text>
					{errorCountRef.current > 1 ? (
						<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
							Si no se resuelve pronto, podemos echarte una mano en el{' '}
							<CTA tag="a" emphasis="tertiary" href="tel:+34800500100">
								800 500 100
							</CTA>
							.
						</Text>
					) : (
						<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
							Vuelve a intentarlo de nuevo
						</Text>
					)}
				</Container>
				<Container padding={{ top: ContainerPadding.dynamic0100 }} horizontalAlign={'center'}>
					<Text color={TokenTextColor.primary} textAlign={TextAlignment.center} bold>
						<CTA tag="button" emphasis="primary" onClick={onVolverClose} aria-label="closePopUp">
							<Text bold>Volver</Text>
						</CTA>
					</Text>
				</Container>
			</Container>
		</ThemeProvider>
	);
};
